const APIs = {
  LOGIN: `api/Auth/LoginBackOffice`,
  AUTO_LOGIN: `/api/Auth/ConsumePosHandoffToken`,
  CREATE_POS_HANDOFF_TOKEN: `/api/Auth/CreatePosHandoffToken`,
  GET_USER_PROFILE: `/api/Staff/GetUserProfile`,
  GET_USER_SETTINGS: `/api/Setting/GetUserSettings`,

  //Company
  GET_COMPANY: `/api/Company/UpdatedCompanyData`,
  GET_COMPANY_PROFILE: `/api/Company/Profile`,
  PUT_UPDATE_COMPANY_DATA: `/api/Company/UpdateCompany`,
  GET_COMPANY_RESTAURANT_CATEGORIES: `/api/Company/RestaurantCategories`,
  PUT_COMPANY_RESTAURANT_CATEGORIES: `/api/Company/RestaurantCategories`,
  POST_UPDATE_WEEKLY_SERVICE_HOURS: `/api/Company/UpdateCompanyServiceHours`,
  POST_UPDATE_COMPANY_LOGO: `/api/Company/UpdateCompanyLogo`,
  DELETE_REMOVE_COMPANY_LOGO: `/api/Company/RemoveCompanyLogo`,
  POST_UPDATE_COMPANY_COVER_IMAGE: `/api/Company/UpdateCompanyCoverImage`,
  DELETE_REMOVE_COMPANY_COVER_IMAGE: `/api/Company/RemoveCompanyCoverImage`,
  GET_COMPANY_SETTINGS: `/api/Setting/GetCompanySettings`,
  UPDATE_COMPANY_SETTINGS: `/api/Setting/UpdateCompanySettings`,
  POST_UPDATE_COMPANY_SETTING: `/api/Setting/UpdateCompanySettings`,

  // Devices
  GET_ALL_DEVICES_OF_COMPANY: `/api/Device/BO_GetCompanyDevices`,
  GET_ALL_DEVICES: `/api/Device/GetCompanyDevices`,
  PATCH_UPDATE_DEVICE_STATUS: `/api/Device/UpdateCompanyStatus`,
  DELETE_COMPANY_DEVICE: `/api/Device/DeleteCompanyDevice`,

  // Payment Gateways
  GET_ALL_PAYMENT_GATEWAYS: `/api/PaymentGateway/BO_GetPaymentGateways`,
  POST_ADD_PAYMENT_GATEWAY: `/api/PaymentGateway/AddPaymentGateway`,
  UPDATE_PAYMENT_GATEWAY: `/api/PaymentGateway/UpdatePaymentGateway`,
  DELETE_PAYMENT_GATEWAY: `/api/PaymentGateway/DeletePaymentGateway`,
  GET_ACTIVE_PAYMENT_GATEWAY_PLATFORMS: `/api/PaymentGatewayPlatform/GetActivePlatforms`,

  //Petty Cash
  GET_PETTY_CASH_HEADS: `/api/PettyCash/BO_GetCashHeads`,
  POST_PETTY_CASH_HEAD: `/api/PettyCash/AddUpdatePettyCash`,
  PUT_UPDATE_PETTY_CASH_HEAD: `/api/PettyCash/AddUpdatePettyCash`,
  GET_PETTY_CASH_HEAD_BY_ID: `/api/PettyCash/GetCashHeadByID`,
  DELETE_PETTY_CASH_HEAD: `/api/PettyCash/DeletePettyCashByID`,
  UPDATE_PETTY_CASH_STATUS: `/api/PettyCash/UpdatePettyCashStatus`,

  // Cash movement report (BackOffice)
  GET_CASH_MOVEMENT_REPORT: `/api/CashReport/BO_GetCashMovementReport`,
  GET_CASH_MOVEMENT_SUMMARY: `/api/CashReport/BO_GetCashMovementSummary`,
  GET_CASH_MOVEMENT_FILTER_OPTIONS: `/api/CashReport/BO_GetCashMovementFilterOptions`,

  // Staff
  GET_COMPANY_STAFF: `api/Staff/BO_GetCompanyStaff`,
  GET_ALL_STAFF: `/api/Staff/GetCompanyStaffList`,
  DELETE_COMPANY_STAFF: `api/Staff/DeleteStaff`,
  GET_STAFF_DATA: `/api/Staff/GetUserByUserName`,
  ADD_STAFF: `/api/Staff/AddUser`,
  UPDATE_STAFF: `/api/Staff/UpdateUser`,
  UPDATE_PASSWORD: `/api/Staff/UpdatePassword`,
  UPDATE_USER_WEEKLY_SCHEDULE: `/api/Staff/UpdateUserWeeklySchedule`,
  UPDATE_STAFF_IMAGE: `/api/Staff/UpdateStaffImage`,
  REMOVE_STAFF_IMAGE: `/api/Staff/RemoveStaffImage`,
  GET_STAFF_ACTIVITY_LOGS: `/api/StaffActivityLog/BO_GetStaffActivityLogs`,
  GET_STAFF_ACTIVITY_REPORT: `/api/StaffActivityLog/BO_GetStaffActivityReport`,
  GET_STAFF_ACTIVITY_SUMMARY_REPORT: `/api/StaffActivityLog/BO_GetStaffActivitySummaryReport`,

   // Staff reports
   /** Staff Shift Report: date-range shift summary (days worked, hours, earnings) */
   GET_ALL_STAFF_SHIFT_REPORTS: `/api/StaffReport/GetAllStaffShiftReports`,
   /** Staff Work Report: date-range sales/work (sale amount, orders, tips, refunds) */
   GET_STAFF_WORK_REPORT_SALES: `/api/StaffReport/GetStaffWorkReport`,
   /** Day-wise shift detail for a single user (used by team/workReport/:UserName) */
   GET_STAFF_WORK_REPORT: `/api/StaffReport/GetStaffShiftReport`,
   /** Alias for Staff Shift Report list */
   GET_ALL_STAFF_WORK_REPORTS: `/api/StaffReport/GetAllStaffShiftReports`,

  // Staff Payouts
  GET_PAYOUTS: `/api/StaffPayout/GetPayouts`,
  GET_UNPAID_HOURS: `/api/StaffPayout/GetUnpaidHours`,
  GENERATE_PAYOUT: `/api/StaffPayout/GeneratePayout`,
  APPROVE_PAYOUT: `/api/StaffPayout/ApprovePayout`,
  PROCESS_PAYOUT: `/api/StaffPayout/ProcessPayout`,
  GET_STAFF_LEAVES: `/api/StaffLeave/GetStaffLeaves`,
  CREATE_STAFF_LEAVE: `/api/StaffLeave/CreateStaffLeave`,
  UPDATE_STAFF_LEAVE: (leaveId) => `/api/StaffLeave/UpdateStaffLeave/${leaveId}`,
  DELETE_STAFF_LEAVE: (leaveId) => `/api/StaffLeave/DeleteStaffLeave/${leaveId}`,
  GET_STAFF_LEAVE_BY_ID: (leaveId) => `/api/StaffLeave/GetStaffLeaveById/${leaveId}`,
  //Roles
  GET_ROLES: `/api/RolePermission/GetAllRoles`,
  GET_ROLE_BY_ID: `/api/RolePermission/GetRoleByID`,
  ADD_ROLE: `/api/RolePermission/AddNewRole`,
  UPDATE_ROLE: `/api/RolePermission/UpdateRolePermission`,
  DELETE_ROLE: `/api/RolePermission/DeleteRole`,

  // Countries
  GET_COUNTRIES: `/api/Country/GetAllCountries`,

  //City
  GET_ALL_CITIES: `/api/City/GetAllCitiesListForCountryCode`,

  // Categories
  GET_CATEGORIES: `/api/RootCategories/BO_GetAllCategories`,
  GET_ALL_REPORTING_CATEGORIES: `/api/RootCategories/GetAllReportingCategories`,
  GET_CATEGORY_ROOT_ID: `/api/RootCategories/GetRootCategoryByRootCatID`,
  ADD_CATEGORY: `/api/RootCategories/AddCategory`,
  UPDATE_CATEGORY: `/api/RootCategories/UpdateCategory`,
  POST_UPDATE_CATEGORY_SORT_ORDER: `/api/RootCategories/UpdateCategorySortOrder`,
  POST_UPDATE_CATEGORY_STATUS: `/api/RootCategories/UpdateCategoryStatus`,
  DELETE_ROOT_CATEGORY: `/api/RootCategories/DeleteCategory`,

  //Category Departments
  GET_ALL_CATEGORY_DEPARTMENTS: `/api/CategoryDepartments/BO_GetCompanyCategoryDepartments`,
  GET_CATEGORY_DEPARTMENT_BY_ID: `/api/CategoryDepartments/GetCategoryDepartmentByID`,
  POST_ADD_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/InsertCategoryDepartment`,
  PUT_UPDATE_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/UpdateCategoryDepartment`,
  DELETE_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/DeleteCategoryDepartment`,
  POST_UPDATE_CATEGORY_DEPARTMENT_SORT_ORDER: `/api/CategoryDepartments/UpdateCategoryDepartmentSortOrder`,

  // Category Types
  GET_ALL_CATEGORY_TYPES: `/api/CategoryType/GetAllCategoryTypes`,
  GET_CATEGORY_TYPE_BY_ID: `/api/CategoryType/GetCategoryTypeByID`,
  POST_ADD_CATEGORY_TYPE: `/api/CategoryType/InsertCategoryType`,
  PUT_UPDATE_CATEGORY_TYPE: `/api/CategoryType/UpdateCategoryType`,
  DELETE_CATEGORY_TYPE: `/api/CategoryType/DeleteCategoryType`,
  POST_UPDATE_CATEGORY_TYPE_SORT_ORDER: `/api/CategoryType/UpdateCategoryTypeSortOrder`,

  // Menus

  POST_ADD_MENU: `/api/Menu/AddMenu`,
  POST_ADD_MENU_GROUP_LIST: `/api/MenuGroup/AddMenuGroupList`,
  GET_MENU_LIST: `/api/Menu/BO_GetAllMenus`,
  GET_MENU_BY_MENU_ID: `/api/Menu/GetMenuByMenuID`,
  GET_All_MENU_GroupS: `/api/Menu/GetAllMenusWithTheirGroups`,
  DELETE_MENU: `/api/Menu/DeleteMenu`,
  PUT_UPDATE_MENU_AND_MENU_GROUP: `/api/Menu/UpdateMenu`,
  POST_UPDATE_MENU_SORT_ORDER: `/api/Menu/UpdateMenuSortOrder`,
  POST_UPDATE_MENU_STATUS: `/api/Menu/UpdateMenuStatus`,

  //  Item
  POST_CREATE_MENU_ITEM: `/api/Item/AddMenuItem`,
  GET_ALL_ITEMS_FOR_GRID: `/api/Item/BO_GetAllItems`,
  GET_ALL_RECIPES: `/api/Item/BO_GetAllRecipes`,
  GET_ALL_RECIPES_BY_COMPANY: `/api/Item/BO_GetAllRecipesForCompany`,
  GET_PRODUCTS_WITHOUT_RECIPES: `/api/Item/GetProductsWithoutRecipes`,
  
 // GET_ALL_PRODUCTS: `/api/Item/GetAllMenuItems`,
  GET_ALL_ONLY_PRODUCTS: `/api/Item/GetAllOnlyMenuItems`,
  GET_ALL_PRODUCTS_FOR_PURCHASE_ORDER: `/api/Item/GetAllProductsForPurchaseOrder`,

  // Recipe Ingredients
  POST_ADD_RECIPE_INGREDIENT: `/api/RecipeIngredient/AddRecipeIngredient`,
  POST_ADD_RECIPE_INGREDIENTS: `/api/RecipeIngredient/AddRecipeIngredients`,
  GET_RECIPE_INGREDIENTS: `/api/RecipeIngredient/GetRecipeIngredients`,
  DELETE_RECIPE_INGREDIENTS: `/api/RecipeIngredient/DeleteRecipeIngredients`,

  // Recipe Batches
  GET_ALL_RECIPE_BATCHES: `/api/RecipeBatch/GetAllRecipeBatches`,
  GET_RECIPE_BATCH_BY_ID: `/api/RecipeBatch/GetRecipeBatchById`,
  POST_ADD_RECIPE_BATCH: `/api/RecipeBatch/AddRecipeBatch`,
  PUT_UPDATE_RECIPE_BATCH: `/api/RecipeBatch/UpdateRecipeBatch`,
  DELETE_RECIPE_BATCH: `/api/RecipeBatch/DeleteRecipeBatch`,
  POST_UPLOAD_PRODUCT_IMAGE: `/api/Item/UploadMenuItemImage`,
  GET_COMPANY_MEDIA: `/api/Media/BO_GetCompanyMedia`,
  POST_UPLOAD_COMPANY_MEDIA: `/api/Media/BO_UploadMedia`,
  POST_UPLOAD_COMPANY_MEDIA_BULK: `/api/Media/BO_UploadMediaBulk`,
  DELETE_COMPANY_MEDIA: `/api/Media/BO_DeleteMedia`,
  POST_SEED_COMPANY_MEDIA: `/api/Media/BO_SeedMediaFromProducts`,
  GET_ITEM_BY_ID: `/api/Item/GetMenuItemByID`,
  PUT_UPDATE_ITEM: `/api/Item/UpdateMenuItem`,
  PUT_BULK_UPDATE_ITEMS: `/api/Item/BulkUpdateMenuItems`,
  POST_BULK_GET_ITEMS: `/api/Item/BulkGetMenuItemsByIds`,
  PUT_UPDATE_ITEM_INVENTORY: `/api/Item/UpdateMenuItemInventory`,
  GET_INVENTORY_STOCK_BY_MENU_ITEM: `/api/Item/GetInventoryStockByMenuItem`,
  POST_ADD_MANUAL_INVENTORY_STOCK: `/api/Item/AddManualInventoryStock`,
  POST_DEDUCT_MANUAL_INVENTORY_STOCK: `/api/Item/DeductManualInventoryStock`,
  DELETE_ITEM: `/api/Item/DeleteMenuItem`,
  PUT_RESTORE_ITEM: `/api/Item/RestoreMenuItem`,
  DELETE_PERMANENT_ITEM: `/api/Item/PermanentDeleteMenuItem`,
  POST_UPDATE_ITEM_SORT_ORDER: `/api/Item/UpdateMenuItemSortOrder`,
  POST_UPDATE_ITEM_STATUS: `/api/Item/UpdateMenuItemStatus`,
  GET_ALL_SHORTED_PRODUCTS: `/api/Item/GetMenuItemsWithShortDetail`,

  // Modifiers
  GET_SEARCH_MODIFIERS: `/api/Modifier/BO_SearchModifier`,

  // Modifier Group

  POST_ADD_MODIFIER_GROUP: `/api/ModifierGroup/AddModifierGroup`,
  GET_ALL_MODIFIER_GROUPS: `/api/ModifierGroup/BO_GetAllModifierGroups`,
  DELETE_MODIFIER_GROUP: `/api/ModifierGroup/DeleteModifierGroup`,
  POST_CHANGE_SKIP_ABLE: `/api/ModifierGroup/ChangeModifierSKipAble`,
  GET_MODIFIER_GROUP_BY_ID: `/api/ModifierGroup/GetModifierGroupByID`,
  PUT_UPDATE_MODIFIER_GROUP: `/api/ModifierGroup/UpdateModifierGroup`,
  POST_ASSIGN_ITEMS_TO_MODIFIER_GROUP: `/api/ItemModifierGroups/AssignItemsToModifierGroup`,
  POST_BULK_ASSIGN_ITEMS_TO_MODIFIER_GROUPS: `/api/ItemModifierGroups/BulkAssignItemsToModifierGroups`,
  GET_ITEM_MODIFIER_GROUPS_RELATIONS: `/api/ItemModifierGroups/GetItemModifierGroupsRelations`,

  //Discount
  GET_ALL_DISCOUNTS: `/api/Discount/BO_GetCompanyDiscountEntry`,
  GET_DISCOUNT_BY_ID: `/api/Discount/GetDiscountByID`,
  POST_ADD_DISCOUNT: `/api/Discount/InsertDiscountEntry`,
  PUT_UPDATE_DISCOUNT: `/api/Discount/UpdateDiscountEntry`,
  DELETE_DISCOUNT: `/api/Discount/DeleteDiscountEntry`,

  // Deals (Combo Deals)
  GET_ALL_DEALS: `/api/Deal/GetAllDeals`,
  GET_ALL_DEALS_FOR_GRID: `/api/Deal/BO_GetAllDeals`,
  GET_DEAL_BY_ID: `/api/Deal/GetDealByID`,
  GET_ACTIVE_PUBLISHED_DEALS: `/api/Deal/GetActivePublishedDeals`,
  POST_ADD_OR_UPDATE_DEAL: `/api/Deal/AddOrUpdateDeal`,
  DELETE_DEAL: `/api/Deal/DeleteDeal`,

  // Deal Slots
  GET_DEAL_SLOTS_BY_DEAL_ID: `/api/DealSlot/GetDealSlotsByDealID`,
  GET_DEAL_SLOT_BY_ID: `/api/DealSlot/GetDealSlotByID`,
  POST_ADD_OR_UPDATE_DEAL_SLOT: `/api/DealSlot/AddOrUpdateDealSlot`,
  DELETE_DEAL_SLOT: `/api/DealSlot/DeleteDealSlot`,

  // Deal Slot Allowed Categories
  GET_DEAL_SLOT_ALLOWED_CATEGORIES: `/api/DealSlotAllowedCategory/GetDealSlotAllowedCategories`,
  POST_ADD_DEAL_SLOT_ALLOWED_CATEGORY: `/api/DealSlotAllowedCategory/AddDealSlotAllowedCategory`,
  DELETE_DEAL_SLOT_ALLOWED_CATEGORY: `/api/DealSlotAllowedCategory/DeleteDealSlotAllowedCategory`,
  DELETE_DEAL_SLOT_ALLOWED_CATEGORIES_BY_SLOT_ID: `/api/DealSlotAllowedCategory/DeleteDealSlotAllowedCategoriesBySlotID`,

  // Deal Slot Allowed Items
  GET_DEAL_SLOT_ALLOWED_ITEMS: `/api/DealSlotAllowedItem/GetDealSlotAllowedItems`,
  POST_ADD_DEAL_SLOT_ALLOWED_ITEM: `/api/DealSlotAllowedItem/AddDealSlotAllowedItem`,
  DELETE_DEAL_SLOT_ALLOWED_ITEM: `/api/DealSlotAllowedItem/DeleteDealSlotAllowedItem`,
  DELETE_DEAL_SLOT_ALLOWED_ITEMS_BY_SLOT_ID: `/api/DealSlotAllowedItem/DeleteDealSlotAllowedItemsBySlotID`,

  // Deal Slot Constraints
  GET_DEAL_SLOT_CONSTRAINT: `/api/DealSlotConstraint/GetDealSlotConstraint`,
  POST_ADD_OR_UPDATE_DEAL_SLOT_CONSTRAINT: `/api/DealSlotConstraint/AddOrUpdateDealSlotConstraint`,
  DELETE_DEAL_SLOT_CONSTRAINT: `/api/DealSlotConstraint/DeleteDealSlotConstraint`,

  // Deal Weekly Timings
  GET_DEAL_WEEKLY_TIMINGS: `/api/DealWeeklyTiming/GetDealWeeklyTimings`,
  POST_ADD_DEAL_WEEKLY_TIMING: `/api/DealWeeklyTiming/AddDealWeeklyTiming`,
  DELETE_DEAL_WEEKLY_TIMING: `/api/DealWeeklyTiming/DeleteDealWeeklyTiming`,

  //Orders
  GET_ALL_ORDERS: `/api/RecvOrder/BO_GetOrders`,
  DELETE_ORDER: `/api/RecvOrder/DeleteRecvOrder`,
  ARCHIEVE_ORDER: `/api/RecvOrder/ArchieveRecvOrder`,
  GET_ORDER_BY_INVOICE_NO: `/api/RecvOrder/GetOrderByInvoiceNo`,

  //Service Time
  GET_ALL_SERVICE_TIME: `/api/ServiceTime/GetAllServiceTimes`,
  GET_SERVICE_TIME_BY_ID: `/api/ServiceTime/GetServiceTimeforID`,
  POST_ADD_SERVICE_TIME: `/api/ServiceTime/AddServiceTime`,
  PUT_UPDATE_SERVICE_TIME: `/api/ServiceTime/UpdateServiceTime`,
  DELETE_SERVICE_TIME: `/api/ServiceTime/DeleteServiceTime`,

  //Service Time Details
  GET_SERVICE_TIME_DETAILS: `/api/ServiceTimeDetail/GetServiceTimeDetailList`,
  GET_SERVICE_TIME_DETAIL_BY_ID: `/api/ServiceTimeDetail/GetAllServiceTimeDetailsByCompany`,
  POST_ADD_SERVICE_TIME_DETAIL: `/api/ServiceTimeDetail/AddServiceTimeDetail`,

  //Service Area
  GET_SERVICE_AREA_BY_ID: `/api/ServiceArea/GetServiceAreaByID`,
  GET_ALL_SERVICE_AREAS: `/api/ServiceArea/GetAllServiceAreas`,
  POST_ADD_SERVICE_AREA: `/api/ServiceArea/AddServiceArea`,
  PUT_UPDATE_SERVICE_AREA: `/api/ServiceArea/UpdateServiceArea`,
  DELETE_SERVICE_AREA: `/api/ServiceArea/DeleteServiceArea`,

  // Customers
  GET_ALL_CUSTOMERS: `/api/Customer/BO_GetCustomerList`,
  GET_CUSTOMER_REPORT: `/api/Customer/GetCustomerReport`,
  GET_ALL_CUSTOMERS_GROUP_TYPE_LIST: `/api/CustomerTypeGroup/GetAllCustomerTypeGroups`,
  GET_CUSTOMERS_GROUP: `/api/CustomerTypeGroup/BO_GetCustomerTypeGroupList`,
  POST_ADD_UPDATE_CUSTOMER_GROUP: `/api/CustomerTypeGroup/AddUpdateCustomerGroup`,
  DELETE_CUSTOMER_GROUP_TYPE: `/api/CustomerTypeGroup/DeleteCustomerGroup`,
  POST_ADD_UPDATE_CUSTOMER: `/api/Customer/AddUpdateCustomer`,
  GET_CUSTOMER_BY_GUID: `/api/Customer/GetCustomerByGuid`,
  
  // PUT_UPDATE_CUSTOMER: `/api/Customer/UpdateCustomer`,
  PATCH_UPDATE_CUSTOMER_EMAIL_ADDRESS: `/api/Customer/UpdateCustomerEmailAddress`,
  DELETE_CUSTOMER_BY_GUID: `/api/Customer/DeleteCustomerByGuid`,

  // Customer Ledger / Wallet
  GET_CUSTOMER_WALLET: `/api/CustomerLedger/BO_GetWallet`,
  GET_CUSTOMER_LEDGER: `/api/CustomerLedger/BO_GetLedger`,
  POST_CUSTOMER_LEDGER_ENTRY: `/api/CustomerLedger/BO_PostEntry`,
  POST_CUSTOMER_LEDGER_REVERSE: `/api/CustomerLedger/BO_ReverseEntry`,

  // Receipt Info
  GET_RECEIPT_INFO: `/api/Receipt/GetReceiptInfo`,
  POST_UPDATE_RECEIPT_INFO: `/api/Receipt/UpdateReceiptInfo`,

  // Currency
  GET_ALL_CURRENCIES: `/api/Shared/GetAllCurrencies`,
  GET_ALL_TIMEZONE: `/api/Shared/GetAllTimeZones`,

  // Voucher
  GET_ALL_VOUCHERS: `/api/Voucher/BO_GetCompanyVouchers`,
  GET_VOUCHER_BY_ID: `/api/Voucher/GetVoucherByID`,
  POST_ADD_VOUCHER: `/api/Voucher/InsertVoucher`,
  PUT_UPDATE_VOUCHER: `/api/Voucher/UpdateVoucher`,
  DELETE_VOUCHER: `/api/Voucher/DeleteVoucher`,

  // Marketplace Campaigns (BackOffice opt-in)
  BO_GET_AVAILABLE_MARKETPLACE_CAMPAIGNS: `/api/MarketplaceCampaign/BO_GetAvailableCampaigns`,
  BO_GET_RESTAURANT_MARKETPLACE_CAMPAIGNS: `/api/MarketplaceCampaign/BO_GetRestaurantCampaigns`,
  BO_REQUEST_CAMPAIGN_OPT_IN: `/api/MarketplaceCampaign/BO_RequestCampaignOptIn`,
  BO_OPT_OUT_MARKETPLACE_CAMPAIGN: `/api/MarketplaceCampaign/BO_OptOutCampaign`,

  // Reports
  GET_TODAY_SALE: `/api/SalesReport/GetTodaySale`,
  /** Dashboard report from order stats (tbl_Recvorder) instead of report tables; includes HourlySalesData in same response */
  GET_TODAY_SALE_FROM_ORDER_STATS: `/api/SalesReport/GetTodaySaleFromOrderStats`,
  GET_TOP_5_SOLD_PRODUCTS: `/api/ProductReport/GetTop5SoldProducts`,
  GET_TOP_5_REPORTING_CATEGORIES: `/api/ProductReport/GetTop5ReportingCategories`,
  GET_HOURLY_SALES_FOR_CHART: `/api/SalesReport/GetHourlySalesForChart`,
  GET_SALES_BREAKDOWN_BY_TIME: `/api/SalesReport/GetSalesBreakdownByTime`,
  GET_SALES_BREAKDOWN_SUMMARY: `/api/SalesReport/GetSalesBreakdownSummary`,
  GET_SALES_BREAKDOWN_BY_PRODUCT: `/api/SalesReport/GetSalesBreakdownByProduct`,
  GET_SALES_BREAKDOWN_BY_PRODUCT_SUMMARY: `/api/SalesReport/GetSalesBreakdownByProductSummary`,
  GET_DEAL_PERFORMANCE_REPORT: `/api/DealPerformanceReport/GetDealPerformanceReport`,
  GET_DEAL_PERFORMANCE_SUMMARY: `/api/DealPerformanceReport/GetDealPerformanceSummary`,
  GET_STAFF_SHIFT_REPORT: `/api/StaffReport/GetStaffShiftReport`,
  GET_COMPANY_LOCATIONS: `/api/Company/GetCompanyLocations`,
  GET_RIDER_REPORT: `/api/RiderReport/GetRiderReport`,
  GET_RESTAURANT_PERFORMANCE: `/api/MarketplaceOrderAudit/BO_GetRestaurantPerformance`,

  // Marketplace restaurant settlements (company-scoped)
  BO_GET_MARKETPLACE_SETTLEMENTS: `/api/MarketplaceRestaurantSettlement/BO_GetSettlements`,
  BO_GET_MARKETPLACE_SETTLEMENT_BY_ID: `/api/MarketplaceRestaurantSettlement/BO_GetSettlementById`,
  BO_GET_MARKETPLACE_SETTLEMENT_REPORT_SUMMARY: `/api/MarketplaceRestaurantSettlement/BO_GetSettlementReportSummary`,
  BO_GET_MARKETPLACE_PAYABLE_ORDERS: `/api/MarketplaceRestaurantSettlement/BO_GetPayableOrders`,
  BO_GET_MARKETPLACE_PAYABLE_ORDER_SUMMARY: `/api/MarketplaceRestaurantSettlement/BO_GetPayableOrderSummary`,

  // Branch Management
  GET_BRANCHES: `/api/Company/GetBranches`,
  POST_ADD_BRANCH: `/api/Company/AddBranch`,
  PUT_UPDATE_BRANCH: `/api/Company/UpdateBranch`,
  DELETE_BRANCH: `/api/Company/DeleteBranch`,
  POST_COPY_PRODUCTS_TO_BRANCH: `/api/Company/CopyProductsToBranch`,

  // Branch Product Assignment
  POST_ASSIGN_PRODUCT_TO_BRANCHES: `/api/BranchProductAssignment/AssignProductToBranches`,
  DELETE_UNASSIGN_PRODUCT_FROM_BRANCH: `/api/BranchProductAssignment/UnassignProductFromBranch`,
  PUT_UPDATE_BRANCH_ASSIGNMENT: `/api/BranchProductAssignment/UpdateBranchAssignment`,
  GET_ASSIGNED_BRANCHES_FOR_PRODUCT: `/api/BranchProductAssignment/GetAssignedBranches`,
  GET_PRODUCTS_BY_BRANCH: `/api/BranchProductAssignment/GetProductsByBranch`,
  GET_PRODUCT_WITH_VARIANTS_BY_BRANCH: `/api/BranchProductAssignment/GetProductWithVariantsByBranch`,
  GET_INVENTORY_STOCK_FOR_BRANCH_VARIANT: `/api/BranchProductAssignment/GetInventoryStockForBranchVariant`,
  GET_ASSIGNED_PRODUCTS_FOR_BRANCH_PURCHASE_ORDER: `/api/BranchProductAssignment/GetAssignedProductsForBranchPurchaseOrder`,
  POST_BULK_ASSIGN_PRODUCTS: `/api/BranchProductAssignment/BulkAssignProducts`,

  // Branch Deal Assignment
  POST_ASSIGN_DEAL_TO_BRANCHES: `/api/BranchDealAssignment/AssignDealToBranches`,
  DELETE_UNASSIGN_DEAL_FROM_BRANCH: `/api/BranchDealAssignment/UnassignDealFromBranch`,
  PUT_UPDATE_BRANCH_DEAL_ASSIGNMENT: `/api/BranchDealAssignment/UpdateBranchDealAssignment`,
  GET_ASSIGNED_BRANCHES_FOR_DEAL: `/api/BranchDealAssignment/GetAssignedBranches`,
  GET_DEALS_BY_BRANCH: `/api/BranchDealAssignment/GetDealsByBranch`,

  // Z-Report
  GET_Z_REPORT_PREVIEW: `/api/ZReport/GetZReportPreview`,
  RUN_Z_REPORT: `/api/ZReport/RunZReport`,
  GET_Z_REPORT_HISTORY: `/api/ZReport/GetZReportHistory`,
  GET_Z_REPORT_HISTORY_PAGINATED: `/api/ZReport/GetZReportHistoryPaginated`,
  GENERATE_Z_REPORT_PDF: `/api/ZReport/GenerateZReportPDF`,
  GET_Z_REPORT_AUTO_SCHEDULE: `/api/ZReport/GetAutoSchedule`,
  POST_UPDATE_Z_REPORT_AUTO_SCHEDULE: `/api/ZReport/UpdateAutoSchedule`,

  // Stock reconciliation report
  POST_STOCK_RECONCILIATION_CREATE: `/api/StockReconciliation/Create`,
  GET_STOCK_RECONCILIATION_BY_ID: (id) => `/api/StockReconciliation/${id}`,
  GET_STOCK_RECONCILIATION_LIST: `/api/StockReconciliation/List`,
  GET_STOCK_RECONCILIATION_LINES: (id) => `/api/StockReconciliation/${id}/Lines`,
  PUT_STOCK_RECONCILIATION_HEADER: (id) => `/api/StockReconciliation/${id}/Header`,
  PATCH_STOCK_RECONCILIATION_LINE: (lineId) => `/api/StockReconciliation/Lines/${lineId}`,
  POST_STOCK_RECONCILIATION_FINALIZE: (id) => `/api/StockReconciliation/${id}/Finalize`,
  POST_STOCK_RECONCILIATION_CANCEL: (id) => `/api/StockReconciliation/${id}/Cancel`,
  POST_STOCK_RECONCILIATION_REFRESH_TO_NOW: (id) => `/api/StockReconciliation/${id}/RefreshToNow`,
  DELETE_STOCK_RECONCILIATION: (id) => `/api/StockReconciliation/${id}/DeleteReconciliation`,
  // Backward-compatible alias for older callers.
  DELETE_STOCK_RECONCILIATION_DRAFT: (id) => `/api/StockReconciliation/${id}/DeleteDraft`,
  POST_STOCK_RECONCILIATION_ADJUST_LINE: (lineId) => `/api/StockReconciliation/Lines/${lineId}/AdjustStock`,

  // Item Purchase Report
  GET_PURCHASE_SUPPLIER_REPORT: `/api/PurchaseReport/GetPurchaseSupplierReport`,
  GET_REQUISITION_REPORT: `/api/PurchaseReport/GetRequisitionReport`,
  GET_INVENTORY_LEDGER_REPORT: `/api/PurchaseReport/GetInventoryLedgerReport`,
  GET_MASTER_INVENTORY_REPORT: `/api/PurchaseReport/GetMasterInventoryReport`,


    // Suppliers
    GET_ALL_SUPPLIERS: `/api/Supplier/BO_GetSupplierList`,
    GET_ALL_SUPPLIERS_BY_COMPANY: `/api/Supplier/GetAllSuppliers`,
    GET_SUPPLIER_BY_ID: `/api/Supplier/GetSupplierByID`,
    POST_ADD_SUPPLIER: `/api/Supplier/AddSupplier`,
    PUT_UPDATE_SUPPLIER: `/api/Supplier/UpdateSupplier`,
    DELETE_SUPPLIER_BY_ID: `/api/Supplier/DeleteSupplierByID`,

    // Supplier-Product Relations
    POST_ADD_SUPPLIER_PRODUCT_RELATION: `/api/Supplier/AddSupplierProductRelation`,
    PUT_UPDATE_SUPPLIER_PRODUCT_RELATION: `/api/Supplier/UpdateSupplierProductRelation`,
    DELETE_SUPPLIER_PRODUCT_RELATION: `/api/Supplier/DeleteSupplierProductRelation`,
    GET_SUPPLIER_PRODUCTS: `/api/Supplier/GetSupplierProducts`,
    GET_PRODUCT_SUPPLIERS: `/api/Supplier/GetProductSuppliers`,
    PUT_SET_PREFERRED_SUPPLIER: `/api/Supplier/SetPreferredSupplier`,

    // Purchase Orders
    POST_CREATE_PURCHASE_ORDER: `/api/PurchaseOrder/CreatePurchaseOrder`,
    PUT_UPDATE_PURCHASE_ORDER: `/api/PurchaseOrder/UpdatePurchaseOrder`,
    DELETE_PURCHASE_ORDER: `/api/PurchaseOrder/DeletePurchaseOrder`,
    GET_PURCHASE_ORDER_BY_ID: `/api/PurchaseOrder/GetPurchaseOrderById`,
    GET_PURCHASE_ORDERS_BY_COMPANY: `/api/PurchaseOrder/GetPurchaseOrdersByCompany`,
    GET_PURCHASE_ORDERS_BY_SUPPLIER: `/api/PurchaseOrder/GetPurchaseOrdersBySupplier`,

    // Purchase Order Products
    POST_ADD_PRODUCT_TO_PO: `/api/PurchaseOrder/AddProductToPurchaseOrder`,
    PUT_UPDATE_PO_PRODUCT: `/api/PurchaseOrder/UpdatePurchaseOrderProduct`,
    DELETE_REMOVE_PRODUCT_FROM_PO: `/api/PurchaseOrder/RemoveProductFromPurchaseOrder`,
    GET_PURCHASE_ORDER_PRODUCTS: `/api/PurchaseOrder/GetPurchaseOrderProducts`,

    // Purchase Order Payments
    POST_ADD_PURCHASE_ORDER_PAYMENT: `/api/PurchaseOrder/AddPurchaseOrderPayment`,
    PUT_UPDATE_PAYMENT_STATUS: `/api/PurchaseOrder/UpdatePaymentStatus`,
    DELETE_PURCHASE_ORDER_PAYMENT: `/api/PurchaseOrder/DeletePurchaseOrderPayment`,
    GET_PURCHASE_ORDER_PAYMENTS: `/api/PurchaseOrder/GetPurchaseOrderPayments`,
    GET_PAYMENTS_BY_COMPANY: `/api/PurchaseOrder/GetPaymentsByCompany`,

    // Receive Purchase Order
    POST_RECEIVE_PURCHASE_ORDER: `/api/PurchaseOrder/ReceivePurchaseOrder`,

    // Requisitions
    POST_CREATE_REQUISITION: `/api/Requisition/CreateRequisition`,
    POST_CLONE_REQUISITION: `/api/Requisition/CloneRequisition`,
    PUT_UPDATE_REQUISITION: `/api/Requisition/UpdateRequisition`,
    GET_REQUISITION_BY_ID: `/api/Requisition/GetRequisitionById`,
    GET_REQUISITIONS_BY_COMPANY: `/api/Requisition/GetRequisitionsByCompany`,
    POST_SUBMIT_REQUISITION: `/api/Requisition/SubmitRequisition`,
    POST_ACCEPT_REQUISITION: `/api/Requisition/AcceptRequisition`,
    POST_SEND_REQUISITION: `/api/Requisition/SendRequisition`,
    POST_RECEIVE_REQUISITION: `/api/Requisition/ReceiveRequisition`,
    POST_ADD_REQUISITION_LINE: `/api/Requisition/AddRequisitionLine`,
    PUT_UPDATE_REQUISITION_LINE: `/api/Requisition/UpdateRequisitionLine`,
    PUT_SAVE_REQUISITION_LINE_SEND_QTY: `/api/Requisition/SaveRequisitionLineSendQty`,
    PUT_SAVE_REQUISITION_LINE_RECEIVED_QTY: `/api/Requisition/SaveRequisitionLineReceivedQty`,
    DELETE_REMOVE_REQUISITION_LINE: `/api/Requisition/RemoveRequisitionLine`,
    GET_REQUISITION_LINES: `/api/Requisition/GetRequisitionLines`,
    GET_ASSIGNED_PRODUCTS_FOR_REQUISITION: `/api/Requisition/GetAssignedProductsForRequisition`,

    // Units
    GET_ALL_UNITS: `/api/Unit/SuperAdmin/GetAllUnits`,

    // Menu Items (additional)
    GET_ALL_MENU_ITEMS: `/api/Item/GetAllMenuItems`,

    GET_TABLE_SPENT_REPORT: `/api/TableReport/GetTableSpent`,
    GET_SERVICE_AREAS: `/api/ServiceArea/GetAllServiceAreas`,

  // Staff order notifications (BackOffice inbox + SignalR; no FCM)
  GET_STAFF_ORDER_NOTIFICATIONS: `/api/StaffOrderNotification/GetNotifications`,
  GET_STAFF_ORDER_UNREAD_COUNT: `/api/StaffOrderNotification/GetUnreadCount`,
  POST_STAFF_ORDER_MARK_READ: `/api/StaffOrderNotification/MarkRead`,
  POST_STAFF_ORDER_MARK_ALL_READ: `/api/StaffOrderNotification/MarkAllRead`,
  HUB_BACKOFFICE_ORDER_NOTIFICATION: `/hub/BackOfficeOrderNotification`,

  // Global Search
  GLOBAL_SEARCH: `/api/Search/GlobalSearch`,

  // Bulk Upload
  GET_BULK_UPLOAD_TEMPLATE: `/api/BulkUpload/GenerateTemplate`,
  POST_BULK_UPLOAD_PROCESS: `/api/BulkUpload/ProcessUpload`,

  // Unit Management
  GET_UNIT_BY_NAME: `/api/Unit/GetUnitByName`,

  // Subscription billing (manual invoices)
  GET_COMPANY_INVOICES: `/api/Invoice/GetCompanyInvoices`,
  GET_INVOICE_BY_ID: `/api/Invoice/GetInvoiceByID`,
  GET_INVOICE_WITH_DETAILS: `/api/Invoice/GetInvoiceWithDetails`,
  GET_TRANSACTIONS_BY_INVOICE: `/api/Payment/GetTransactionsByInvoiceID`,
  GET_ACTIVE_BILLING_BANK_ACCOUNTS: `/api/BillingBankAccount/GetActiveBankAccounts`,
  GET_STRIPE_PUBLISHABLE_KEY: `/api/BillingSettings/GetStripePublishableKey`,
  POST_CREATE_STRIPE_CHECKOUT: `/api/Payment/CreateStripeCheckoutSession`,
  POST_CONFIRM_STRIPE_CHECKOUT: `/api/Payment/ConfirmStripeCheckout`,
  POST_RECORD_BANK_TRANSFER: `/api/Payment/RecordBankTransferPayment`,
  POST_UPLOAD_PAYMENT_PROOF: `/api/Payment/UploadPaymentProof`,

  // Public support contact (SuperAdmin-managed)
  GET_SUPPORT_INFO: `/api/SupportInfo/GetSupportInfo`,

  // Go Fatafat marketplace restaurant settings
  GET_GOFATAFAT_SETTINGS: `/api/GoFatafatSettings`,
  PUT_GOFATAFAT_SETTINGS: `/api/GoFatafatSettings`,
  POST_GOFATAFAT_BREAK: `/api/GoFatafatSettings/break`,
  DELETE_GOFATAFAT_BREAK: `/api/GoFatafatSettings/break`,
};

export default APIs;
